var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit",
      "loading": _vm.loadingImport
    },
    on: {
      "ok": _vm.handleImport
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModal = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), !_vm.loadingExportTemplate ? _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")]) : _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    }
  }), _vm._v(" Downloading ")], 1)]], 2), _c('b-modal', {
    attrs: {
      "title": "Import Result",
      "size": "xl",
      "hide-footer": ""
    },
    model: {
      value: _vm.modalResponseImport,
      callback: function callback($$v) {
        _vm.modalResponseImport = $$v;
      },
      expression: "modalResponseImport"
    }
  }, [_c('ImportResultRh', {
    attrs: {
      "response": _vm.dataResponseImport
    }
  })], 1), _c('b-modal', {
    attrs: {
      "title": "Remarks",
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: _vm.showModalRemarks,
      callback: function callback($$v) {
        _vm.showModalRemarks = $$v;
      },
      expression: "showModalRemarks"
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('p', {
    staticClass: "text-black"
  }, [_vm._v(_vm._s(_vm.selectedRemarks))])])]), _c('custom-sidebar', {
    attrs: {
      "size": "xl",
      "title": _vm.selectedData ? 'Detail Adjustment GOH' : 'Add Adjustment GOH'
    },
    model: {
      value: _vm.showCanvas,
      callback: function callback($$v) {
        _vm.showCanvas = $$v;
      },
      expression: "showCanvas"
    }
  }, [_c('div', {
    staticClass: "p-4 bg-white shadow-sm",
    staticStyle: {
      "border-radius": "10px"
    }
  }, [_vm.showCanvas ? _c('FormGoh', {
    attrs: {
      "selectedData": _vm.selectedData
    },
    on: {
      "refetch": function refetch() {
        _vm.fetchData();
        _vm.showCanvas = false;
      },
      "close": function close($event) {
        _vm.showCanvas = false;
      }
    }
  }) : _vm._e()], 1)]), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("ADJUSTMENT KICK OFF GOH")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$rhData$data, _vm$rhData$data2;
        return [_c('b-row', [_c('FilterRh', {
          attrs: {
            "filters": _vm.filters
          }
        }), _c('b-col', {
          staticClass: "d-flex justify-content-end",
          attrs: {
            "lg": "6"
          }
        }, [_c('b-button', {
          staticClass: "d-flex align-items-center mx-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModal = true;
            }
          }
        }, [_c('i', {
          staticClass: "ri-download-2-line pl-1"
        }), _vm._v(" Import ")]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showCanvas = true;
              _vm.selectedData = null;
            }
          }
        }, [_vm._v(" Create Adjustment Kick Off GOH ")])], 1), !_vm.loading ? [(_vm$rhData$data = _vm.rhData.data) !== null && _vm$rhData$data !== void 0 && _vm$rhData$data.length ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "overflow-auto",
          staticStyle: {
            "position": "relative"
          }
        }, [_c('table', {
          staticClass: "w-100 table-striped table-hover"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticStyle: {
            "min-width": "20%"
          }
        }, [_vm._v("FLEET NAME")]), _c('th', {
          staticStyle: {
            "min-width": "40%"
          }
        }, [_vm._v("ENGINE NAME")]), _c('th', {
          staticStyle: {
            "min-width": "20%"
          }
        }, [_vm._v("EFFECTIVE DATE")]), _c('th', {
          staticStyle: {
            "min-width": "20%"
          }
        }, [_vm._v("KICK OFF GOH")])])]), _c('tbody', [_vm._l(_vm.rhData.data, function (item, itemIndex) {
          return _vm._l(item.powers, function (power, powerIndex) {
            var _power$power_series_d, _power$power_series_d2;
            return _c('tr', {
              key: "".concat(item.id, "-").concat(power.id),
              class: {
                'border-bottom-yellow': powerIndex === item.powers.length - 1
              }
            }, [powerIndex === 0 ? _c('td', {
              staticClass: "align-middle bg-white border-right-light",
              attrs: {
                "rowspan": item.powers.length
              }
            }, [_c('div', {
              staticClass: "mb-2"
            }, [_c('b-button', {
              staticClass: "text-truncate w-100",
              attrs: {
                "variant": "success",
                "size": "sm"
              }
            }, [_vm._v(" " + _vm._s(item.vehicle_name || '-') + " ")])], 1), _c('b-dropdown', {
              staticClass: "w-100",
              attrs: {
                "size": "sm",
                "variant": "outline-primary",
                "text": "Action",
                "right": ""
              }
            }, [_c('b-dropdown-item', {
              on: {
                "click": function click($event) {
                  return _vm.handleDetail(item);
                }
              }
            }, [_c('i', {
              staticClass: "fa fa-eye mr-2"
            }), _vm._v(" Detail ")]), _c('b-dropdown-item', {
              staticClass: "text-danger",
              on: {
                "click": function click($event) {
                  return _vm.handleDelete(item);
                }
              }
            }, [_c('i', {
              staticClass: "fa fa-trash-alt text-danger mr-2"
            }), _vm._v(" Delete ")])], 1)], 1) : _vm._e(), _c('td', [_c('div', {
              staticClass: "font-weight-bold"
            }, [_vm._v(" " + _vm._s(power.power_type) + " ")]), _c('div', {
              staticClass: "text-muted small"
            }, [_vm._v(" " + _vm._s((_power$power_series_d = power.power_series_detail) === null || _power$power_series_d === void 0 ? void 0 : _power$power_series_d.name) + " - " + _vm._s((_power$power_series_d2 = power.power_series_detail) === null || _power$power_series_d2 === void 0 ? void 0 : _power$power_series_d2.model) + " ")])]), _c('td', [_vm._v(" " + _vm._s(_vm.formatDate(power.effective_date)) + " ")]), _c('td', [_vm._v(_vm._s(_vm.formatNumber(power.kick_off_goh)) + " Hours")])]);
          });
        })], 2)])]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('p', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows: "), _c('strong', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s(_vm.rhData.params.total))])]), _c('div', {
          staticClass: "d-flex justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.rhData.params.total,
            "per-page": _vm.rhData.params.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": function change(page) {
              _vm.rhData.params.page = page;
              _vm.fetchData();
            }
          },
          model: {
            value: _vm.rhData.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.rhData.params, "page", $$v);
            },
            expression: "rhData.params.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.rhData.params.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.rhData.params, "limit", $$v);
            },
            expression: "rhData.params.limit"
          }
        })], 1)])]) : _vm._e()] : [_c('div', {
          staticClass: "w-100 d-flex justify-content-center align-items-center my-5 py-5"
        }, [_c('b-spinner')], 1)], !((_vm$rhData$data2 = _vm.rhData.data) !== null && _vm$rhData$data2 !== void 0 && _vm$rhData$data2.length) && !_vm.loading ? [_c('b-col', {
          attrs: {
            "cols": "12"
          }
        }, [_vm._v("No Data Here!")])] : _vm._e()], 2)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }